import React, { useRef } from 'react';
import { useReactToPrint } from 'react-to-print';
import moment from 'moment';

const PdfPacientesDietaZero = ({ title, list, theme }) => {
  const componentRef = useRef();
  const textIcon = (theme === 'dark' ? '_dark' : ''); 

  const handlePrint = useReactToPrint({
    documentTitle: 'Relatório de Pacientes em Dieta Zero',
    content: () => componentRef.current,
  });

  return (
    <>
      <button className={'buttonIcon '+theme}><img src={"/img/icon_printer"+textIcon+".svg"} alt="" onClick={handlePrint} /></button>
      <div style={{ display: 'none' }}>
        <div ref={componentRef} style={{ width: '100%', height: window.innerHeight }}>
          <div className='inforow' style={{marginTop: '40px',marginLeft: '80px', marginRight: '80px'}}>
            <div className="inforow right">
              <h3 style={{fontSize: '18px'}}>{title}</h3 >
            </div>
            <div className="inforow left">
              <img src="/img/logo_powered_insightcare.png" alt="Insightcare" style={{width: '12vw', position:'relative', marginLeft: '32px', float: 'right'}}/>
              <img src="/img/logo_gruposanta.png" alt="Gruposanta" style={{width: '12vw', position:'relative', float: 'right', marginLeft: '25px'}}/>
            </div>
          </div>
          <div className="inforow" style={{marginLeft: '80px', marginRight: '80px'}}>
            <div className='inforow right'>
              <div className='infoText' style={{fontSize: '12px'}}>Mostrando {list.length} pacientes </div>
            </div>
            <div className='inforow left'>
              <div className='infoText' style={{fontSize: '12px'}}>Impresso em {moment().format('HH:mm, [dia] D [de] MMMM [de] YYYY')}</div>
            </div>
          </div>
          <div className='tablePDF'>
            <table>
              <thead>
                <tr>
                <th>Dieta Vigente</th>
                <th>Paciente</th>
                <th>Leito </th>
                <th>Código Atendimento</th>
                <th>Tempo</th>
                </tr>
              </thead>
              <tbody>
                {list.map((data) => {
                  let color = '';
                  let statusClass = "ready";
                  let tdClassFarm = "";
                  let spanClassFarm = "";
                  let key = "tr-" + data.ID;
                  var days = 0;
                  var rdays = 0;
                  var hours = 0;
                  var rhours = 0;
                  var minutes = 0;
                  var rminutes = 0;
                  
                  let time = data.MinutosInicio;
                  if (data.MinutosInicio > 60) {
                    if (data.MinutosInicio > 1440) {
                      days = (data.MinutosInicio / 1440);
                      rdays = Math.floor(days);
                      hours = (days - rdays) * 24;
                      rhours = Math.floor(hours);
                      minutes = (hours - rhours) * 60;
                      rminutes = Math.round(minutes);
                      time = rdays + " d " + rhours + " h " + rminutes + " m";
                      statusClass = "canceled";
                    } else {
                      hours = (data.MinutosInicio / 60);
                      rhours = Math.floor(hours);
                      minutes = (hours - rhours) * 60;
                      rminutes = Math.round(minutes);
                      time = rhours + " h " + rminutes + " m";
                      statusClass = "ready";
                    }
                  } else {
                    time = time + ' mins';
                  }

                  return (
                    <tr key={key} className={statusClass}>
                    <td style={{ color: color , overflowWrap: 'break-word', wordWrap: 'break-word'}} align="left">{data.DietaVigente}</td>
                    <td style={{ overflow: 'hidden', whiteSpace: 'nowrap', color: color }} align="left"><b>{data.Paciente}</b> </td>
                    <td style={{ overflow: 'hidden', whiteSpace: 'nowrap' }} align="left">{data.Leito}</td>
                    <td className={tdClassFarm} align="left"><span className={spanClassFarm}></span>{data.CodigoAtendimento}</td>
                    <td style={{ color: color }} align="left">{time}</td>  
                    </tr>
                  )
                })
                }
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </>
  );
};

export default PdfPacientesDietaZero;